import { gql } from '@apollo/client';
const GET_CURRENT_TENANT_BRANDS = gql `
  query GetCurrentTenantBrands($first: Int = 25, $after: String = "") {
    me {
      id
      currentTenant {
        id
        brands(first: $first, after: $after) {
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              name
              canNameBeUpdated
              canBeRemoved
            }
          }
        }
      }
    }
  }
`;
export default GET_CURRENT_TENANT_BRANDS;
